import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';

import {
	ThreeAlternatingImageText,
	PatternThreeAlternatingImageTextProps,
} from '@/patterns/three-alternating-image-text/src/three-alternating-image-text';

import { PaidLandingTypes } from '../src/paid-landing.template';

const anchorPageStyles = css({
	// overriding custom results styles in three-alternating-image-text.tsx
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'p.contentBlock-body': {
		[media.above.lg]: {
			fontSize: '20px',
		},
	},
});

const confluenceAnchorStyles = css({
	// overriding custom results styles in three-alternating-image-text.tsx
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.text-section h2': {
		fontSize: '2rem',
		fontWeight: '700',
	},
	// overriding custom results styles in three-alternating-image-text.tsx
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.text-section p': {
		fontSize: '1.25rem',
	},
});

interface PaidAlternatingImageTextProps {
	alternatingImageTextProps?: PatternThreeAlternatingImageTextProps;
	landingType: PaidLandingTypes;
}

export const PaidAlternatingImageText = ({
	alternatingImageTextProps,
	landingType,
}: PaidAlternatingImageTextProps) => {
	if (!alternatingImageTextProps) {
		return null;
	}
	return (
		<div
			css={[
				landingType === 'jira-software-anchor' && anchorPageStyles,
				landingType === 'confluence-rebranded-anchor' && confluenceAnchorStyles,
			]}
		>
			<ThreeAlternatingImageText {...alternatingImageTextProps} />
		</div>
	);
};
PaidAlternatingImageText.displayName = 'PaidAlternatingImageText';
